import { Component, DestroyRef, Inject, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MatDialogModule,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { MatIconModule } from '@angular/material/icon';
import { OrderState } from '../../../state/order/order.reducer';
import { Observable } from 'rxjs';
import { Order } from '../../../models/Order';
import { selectCurrentOrder } from '../../../state/order/order.selector';
import { useCoins, useCoinsFailure, useCoinsSuccess } from '../../../state/order/order.actions';
import { CustomerState } from '../../../state/customer/customer.reducer';
import { updateCoins } from '../../../state/customer/customer.actions';
import { Actions, ofType } from '@ngrx/effects';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

export interface DialogData {
  coins: number;
  orderId: number;
}

@Component({
  selector: 'app-confirm-coins-dialog',
  imports: [MatDialogModule, MatButtonModule, MatIconModule],
  templateUrl: './confirm-coins-dialog.component.html',
  styleUrls: ['./confirm-coins-dialog.component.css'],
})
export class ConfirmCoinsDialogComponent {
  readonly data = inject<DialogData>(MAT_DIALOG_DATA);
  order$: Observable<Order | null>;
  private readonly destroyRef = inject(DestroyRef);
  private pendingCoinsUpdate:
    | {
        userName: string;
        coins: number;
      }
    | null = null;

  constructor(
    private dialogRef: MatDialogRef<ConfirmCoinsDialogComponent>,
    private orderStore: Store<{ order: OrderState }>,
    private customerStore: Store<{ customer: CustomerState }>,
    private actions$: Actions
  ) {
    this.order$ = orderStore.select(selectCurrentOrder);

    this.actions$
      .pipe(
        ofType(useCoinsSuccess),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        if (this.pendingCoinsUpdate) {
          this.customerStore.dispatch(
            updateCoins({
              request: {
                userName: this.pendingCoinsUpdate.userName,
                coins: this.pendingCoinsUpdate.coins,
                operation: 'subtract',
              },
            })
          );
          this.pendingCoinsUpdate = null;
        }
        this.dialogRef.close(true);
      });

    this.actions$
      .pipe(
        ofType(useCoinsFailure),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.pendingCoinsUpdate = null;
      });
  }

  useCoins() {
    const userName = localStorage.getItem('userName') || '';
    this.pendingCoinsUpdate = {
      userName,
      coins: this.data.coins,
    };
    this.orderStore.dispatch(
      useCoins({
        userName,
        reflexId: this.data.orderId.toString(),
        coins: this.data.coins,
      })
    );
  }
  cancel() {
    this.dialogRef.close();
  }
}
